'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/help-button.js';
exports.default = HelpButton;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _icon = require('@marmalade/icon');
var _icon2 = _interopRequireDefault(_icon);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _componentThemes$help = _themes.componentThemes.helpInfo,
  helpButtonStyle = _componentThemes$help.helpButtonStyle,
  helpInfoVariants = _componentThemes$help.helpInfoVariants,
  helpInfoTheme = _componentThemes$help.helpInfoTheme;
var helpButtonStyles = function helpButtonStyles(props) {
  var theme = helpInfoTheme(props.theme);
  return {
    cursor: 'pointer',
    color: theme[helpButtonStyle('color', helpInfoVariants[props.type])]
  };
};
HelpButton.propTypes = {
  onClick: _propTypes.func.isRequired,
  type: (0, _propTypes.oneOf)(['help', 'warning'])
};
HelpButton.defaultProps = {
  type: 'help'
};
var Button = _glamorous2.default.span(helpButtonStyles);
function HelpButton(props) {
  return _react2.default.createElement(Button, Object.assign({
    role: 'button',
    tabIndex: 0
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }), _react2.default.createElement(_icon2.default, {
    type: 'question',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31
    },
    __self: this
  }));
}